import type { AddToCartData, CartEntryData } from '../types';
import type { Checkout, CheckoutOption } from './types';
import {
  dataLayerAddToCart,
  dataLayerCheckout,
  dataLayerCheckoutOption,
  dataLayerDecreaseQuantity,
  dataLayerIncreaseQuantity,
  dataLayerListView,
  dataLayerProductDetailsView,
  dataLayerProductDetailsViewUpdate,
  dataLayerPurchase,
  dataLayerRemoveFromCart,
  dataLayerRolexProductDetailsView,
  dataLayerRolexContactUsFormSubmitted,
  dataLayerRolexContactUsCallButtonClicked,
  dataLayerRolexContactUsGetDirectionsButtonClicked
} from './datalayer/datalayer';
import { Activities, attraqtTracker } from './attraqt/attraqtTracker';
import attraqtTrackerAddToCart from './attraqt/attraqtTrackerAddToCart';
import attraqtTrackerPurchase from './attraqt/attraqtTrackerPurchase';
import attraqtTrackerRemoveFromCart from './attraqt/attraqtTrackerRemoveFromCart';
import { isAlreadyTracked } from './datalayer/helpers';

export const trackListView = (): void => {
  dataLayerListView();
};

export const trackProductDetailsView = (): void => {
  dataLayerProductDetailsView();
  attraqtTracker({
    action: Activities.VIEW,
    target: {
      product: window.globalProductDetails.attraqt.fhProductCode
    }
  });
};

export const trackProductDetailsViewUpdate = (): void => {
  dataLayerProductDetailsViewUpdate();
};

export const trackAddToCart = (responseData: AddToCartData): void => {
  attraqtTrackerAddToCart(responseData);
  dataLayerAddToCart(responseData);
};

const trackIncreaseQuantity = (cartEntry: CartEntryData): void => {
  dataLayerIncreaseQuantity(cartEntry);
};

const trackDecreaseQuantity = (cartEntry: CartEntryData): void => {
  dataLayerDecreaseQuantity(cartEntry);
};

const trackRemoveFromCart = (cartEntry: CartEntryData): void => {
  attraqtTrackerRemoveFromCart(cartEntry.fhProductCode);
  dataLayerRemoveFromCart(cartEntry);
};

export const trackChangeQuantity = (cartEntry: CartEntryData, newQuantity: number): void => {
  if (newQuantity === 0) {
    trackRemoveFromCart(cartEntry);
  } else if (cartEntry.quantity > newQuantity) {
    trackDecreaseQuantity(cartEntry);
  } else {
    trackIncreaseQuantity(cartEntry);
  }
};

export const trackCheckout = (checkoutData: Checkout): void => {
  dataLayerCheckout(checkoutData);
};

export const trackCheckoutOption = (option: CheckoutOption): void => {
  dataLayerCheckoutOption(option);
};

export const trackPurchase = (): void => {
  if (!isAlreadyTracked()) {
    dataLayerPurchase();
    attraqtTrackerPurchase();
  }
};

export const trackRolexProductDetailsView = (): void => {
  dataLayerRolexProductDetailsView();
  attraqtTracker({
    action: Activities.VIEW,
    target: {
      product: window.globalProductDetails.attraqt.fhProductCode
    }
  });
};

export const trackSubmitRolexContactUsForm = (): void => {
  dataLayerRolexContactUsFormSubmitted();
};

export const trackClickRolexContactUsCallButton = (): void => {
  dataLayerRolexContactUsCallButtonClicked();
};

export const trackClickRolexContactUsGetDirectionsButton = (): void => {
  dataLayerRolexContactUsGetDirectionsButtonClicked();
};
